const INITIAL_STATE = {
  data: {},
  errors: {},
          
}
        
const getServiceRouteCSVFormat = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_SERVICE_ROUTE_PDF_DOWNLOAD_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_SERVICE_ROUTE_PDF_DOWNLOAD_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
          
export default getServiceRouteCSVFormat;